module.exports = __webpack_public_path__ + "img/network_chart_light.ae211e1c.png";